import { fabric } from 'fabric';
import { FABRIC_CUSTOM_OBJECT } from '../../../utils';

let circleControl = null;

export function createControlSlider(e) {
  const { target } = e;
  const { canvas } = window;
  circleControl = new fabric.Circle({
    ...target.circleStyle,
    name: FABRIC_CUSTOM_OBJECT.circleSlider,
    originX: 'center',
    originY: 'center',
    lockMovementY: true,
    // hasControls: false,
    // hasBorders: false,
    lockRotation: true,
    isNotObj: true,
    parentObj: target,
    padding: 10,
    borderColor: 'blue',
    // borderScaleFactor: 2,
    top: target.top + target.height / 2 + target.strokeWidth / 2,
    left: target.left + (target.width * target.percent) / 100 + target.strokeWidth / 2,
  });
  circleControl.set({
    defaultTop: circleControl.top,
    defaultLeft: circleControl.left,
  });
  circleControl.setCoords();
  target.circleStyle = { ...target.circleStyle, fill: 'transparent', stroke: 'transparent' };
  canvas.remove(target);
  canvas.add(target);
  canvas.add(circleControl);
  canvas.setActiveObject(circleControl);
  return true;
}
function calculatorPercentage(circle, obj) {
  return ((circle.left - obj.left - obj.strokeWidth / 2) * 100) / obj.width;
}
export function controlSliderMoving(e) {
  const { target } = e;
  const mySlider = target.parentObj;
  const { radius } = target;
  const rx = parseInt(mySlider.rx);

  const epsRight = mySlider.strokeWidth / 2 + mySlider.height / 2 - rx;
  if (target.left > mySlider.left + mySlider.width - radius + epsRight) {
    target.set({ left: mySlider.left + mySlider.width - radius + epsRight });
    target.setCoords();
  }

  const epsLeft = mySlider.height / 2 - rx;
  if (target.left < mySlider.left + radius - epsLeft) {
    target.set({ left: mySlider.left + radius - epsLeft });
    target.setCoords();
  }
  target.set({
    defaultTop: target.top,
    defaultLeft: target.left,
  });
  mySlider.set({ percent: calculatorPercentage(target, mySlider) });
  mySlider.setCoords();

  return true;
}

export function controlSliderModified(e) {
  if (e.scaleX !== 1) e.set({ radius: e.radius * e.scaleX });
  else e.set({ radius: e.radius * e.scaleY });
  e.set({ radius: Math.max(e.parentObj.height / 2, e.radius) });
  e.set({
    top: e.defaultTop,
    left: e.defaultLeft,
    scaleX: 1,
    scaleY: 1,
  });
  // e.setCoords();
  return true;
}
export function controlRemove(target) {
  const { canvas } = window;
  const mySlider = target.parentObj;
  const { fill, radius, stroke, strokeWidth, opacity, scaleX, scaleY, originX, originY } = target;
  mySlider.set({
    circleStyle: {
      fill,
      radius,
      stroke,
      strokeWidth,
      opacity,
      scaleX,
      scaleY,
      originX,
      originY,
    },
    padding: Math.abs(target.radius - mySlider.height / 2),
  });
  mySlider.setCoords();
  canvas.remove(mySlider);
  canvas.add(mySlider);
  canvas.remove(target);
  return true;
}
